import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';


interface ResendData {
  users: any;
  title: string;
  buttonText: string;
}

@Component({
  standalone: false,
  selector: 'app-resend-invite-dialog',
  templateUrl: './resend-invite-dialog.component.html',
  styleUrls: ['./resend-invite-dialog.component.scss']
})


export class ResendInviteDialogComponent  implements OnInit {
  private paginator: MatPaginator;
  public buttonText = 'Resend';
  displayedColumns = ['status', 'email'];
  dataSource = new MatTableDataSource();
  usersCount: number;
  @ViewChild(MatPaginator, { static: false }) set matPaginator(
    mp: MatPaginator
  ) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }

  constructor(@Inject(MAT_DIALOG_DATA) public data: ResendData) {}

  ngOnInit() {
    this.dataSource.data = this.data.users;
    if (this.data.buttonText) {
      this.buttonText = this.data.buttonText;
    }
    this.setDataSourceAttributes();
  }

  setDataSourceAttributes() {
    this.dataSource.paginator = this.paginator;
  }
}
